import React from 'react';
import { aboutContent } from '../data/mock';
import { Award, Camera, Users } from 'lucide-react';

const About = () => {
  const bioParagraphs = aboutContent.bio.split('\n\n');

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=800&q=80"
                alt="Diane Neill"
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                <Award className="w-8 h-8 mx-auto mb-2 text-gray-900" />
                <p className="text-3xl font-bold text-gray-900">{aboutContent.stats.experience}</p>
                <p className="text-sm text-gray-600">Experience</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                <Camera className="w-8 h-8 mx-auto mb-2 text-pink-500" />
                <p className="text-3xl font-bold text-gray-900">{aboutContent.stats.concerts}</p>
                <p className="text-sm text-gray-600">Concerts</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                <Users className="w-8 h-8 mx-auto mb-2 text-pink-500" />
                <p className="text-3xl font-bold text-gray-900">{aboutContent.stats.clients}</p>
                <p className="text-sm text-gray-600">Clients</p>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div>
            <p className="text-sm uppercase tracking-wider text-gray-500 mb-2">About Me</p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Diane Neill</h2>
            <h3 className="text-2xl font-semibold text-gray-700 mb-6">{aboutContent.title}</h3>
            
            <div className="space-y-4">
              {bioParagraphs.map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mt-8">
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-3 bg-pink-500 text-white font-semibold rounded-md hover:bg-pink-600 transition-all transform hover:scale-105 shadow-lg"
              >
                Work With Me
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
